<template>
  <div class="custom-analysis-table-cell-value">
    <div class="zhibiao-idx" :style="{ color: row.color }" v-if="colName === 'target_name'">
      {{ row.zhibiaoIdxChar }}{{ row.dzzIdxChar }}
    </div>
    <div class="data-cont">
      <div>
        <div v-for="(v, idx) in valArr" :key="idx">
          <num-popver
            v-if="checkCanExportCrowd(v)"
            @onConfirm="handleSubmitSaveCrowd({ row: row, col: col, idx }, ...arguments)"
          >
            <span class="num-export data-number" :class="{ compare: idx > 0 }">
              {{ v.toLocaleString() }}
            </span>
          </num-popver>
          <div v-else class="data-number" :class="{ compare: idx > 0 }">{{ v.toLocaleString() }}</div>
        </div>
      </div>
      <template v-if="showCompareDate && colName !== 'target_name' && col.type !== 'weidu' && col.field !== 'date'">
        <div class="sep"></div>
        <div class="percent" :class="{ up: percentUp, down: percentDown }">
          {{ percentUp ? '+' : '' }}{{ percentDown ? '-' : '' }}{{ percent }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import { beautifyNumber } from '@/view/pages/custom-common/helper';
import NumPopver from './num-popover.vue';
import { getWeiduValueDesc } from '@/utils/helper';

export default {
  name: 'table-cell-value',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    NumPopver,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
    col: {
      type: Object,
      required: true,
    },
    colName: {
      type: String,
      required: true,
    },
    showCompareDate: {
      type: Boolean,
    },
    canExportNumCols: {
      type: Array,
      default: () => [],
    },
    lastGetDataParams: {
      // 最后一次成功请求数据的参数。因为用户可以随时更改页面上的配置，而不实际请求数据
      type: Object,
    },
    lastGetDataParamsCompare: {
      type: Object,
    },
  },
  data() {
    return {
      valArr: '',
      percent: '',
      percentUp: false,
      percentDown: false,
    };
  },
  watch: {
    row: {
      deep: true,
      handler() {
        this.init();
      },
    },
    colName: {
      deep: true,
      handler() {
        this.init();
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    reset() {
      this.percentUp = false;
      this.percentDown = false;
    },
    init() {
      this.reset();

      let v = this.row[this.colName];
      if (v === undefined) {
        v = '-';
      }
      if (Array.isArray(v)) {
        this.valArr = v;
      } else {
        this.valArr = [v];
      }

      this.valArr = this.valArr.map(tv => {
        if (this.colName === 'globalFilterIndex') {
          return getWeiduValueDesc(this.lastGetDataParams, { val: this.colName }, this.row);
        }
        return tv;
      });

      if (this.valArr.length > 1) {
        const [first, second] = this.valArr;
        if (first === '-') {
          this.percent = '-';
        } else if (second === '-' || Number(second) === 0) {
          this.percent = 0;
        } else {
          const tmpPercent = (first - second) / second;
          this.percentUp = tmpPercent > 0;
          this.percentDown = tmpPercent < 0;
          this.percent = `${(Math.abs(tmpPercent) * 100).toFixed(2)}%`;
        }
      }
    },
    checkCanExportCrowd(val) {
      return this.canExportNumCols.includes(this.colName) && !!this.row.canRowExportCrowd && val > 0;
    },
    handleSubmitSaveCrowd(...args) {
      this.$emit('submitSaveCrowd', ...args);
    },
  },
};
</script>

<style lang="less" scoped>
.custom-analysis-table-cell-value {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .data-cont {
    display: flex;
    align-items: center;

    .data-number {
      color: #222;
      &.compare {
        color: #8492a6;
      }
    }

    .sep {
      width: 1px;
      height: 32px;
      background-color: #e8edf4;
      margin: 0 5px 0 10px;
    }

    .percent {
      width: 60px;
    }

    .up {
      color: red;
      position: relative;
    }
    .down {
      color: green;
      position: relative;
    }
  }
}
</style>
